export default __webpack_public_path__ + "images/8a67deada198ce5cc4cc32ebfd66ed37.png";